import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

/** How much work a background queue holds: tasks waiting for a worker, and tasks a worker is running. */
@Entity()
export class JobQueueStatus extends AdornisEntity {
  static override _class = 'JobQueueStatus';

  @Field(() => Int)
  queued: Maybe<number>;

  @Field(() => Int)
  running: Maybe<number>;
}
